module.exports = __webpack_public_path__ + "img/second_zhCn.9f49a0c7.png";